var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{on:{"resetContaionerSize":_vm.resizeCallback,"setBodyBackground":_vm.setBodyBackground,"spinScreen":_vm.spinScreen}})
}
var staticRenderFns = []

export { render, staticRenderFns }